export const ExportFileTypeEnum = {
    Excel: 0,
    CSV: 1,
    PDF: 2,
};

type constExportFileTypeEnumType = typeof ExportFileTypeEnum;

export type ExportFileTypeEnum = constExportFileTypeEnumType[keyof constExportFileTypeEnumType];
